<template>

    <div class="top-btns-bar" v-if="getMenu.length > 0">

        <div class="transparent-buttons">
            <v-btn
                v-for="(item, index) in getMenu"
                :key="item.Action + index"
                @click="onToolbarButtonClick($event, item)"
                small
                tile
                text
                :disabled="btnIsLock(item.Action)"
            >
                <v-popover :trigger="item.Items ? 'click' : 'hover'">
                    <v-icon left>
                        {{mapIcon(item.Icon)}}
                    </v-icon>
                    <template>
                        {{ $t(item.Text) }}
                    </template>

                    <template slot="popover">
                        <ul class="ribbon-button-submenu" v-if="item.Items">
                            <li
                                v-for="(itemSub, indexSub) in item.Items"
                                :key="itemSub.Action + indexSub"
                                @click="onToolbarButtonClick($event, itemSub)"
                                v-close-popover
                            >
                                <v-icon left>
                                    {{ mapIcon(itemSub.Icon) }}
                                </v-icon>
                                <template>
                                    {{ $t(itemSub.Text) }}
                                </template>
                            </li>
                        </ul>
                        <template>
                            <span class="ribbon-button-submenu-title">{{ $t(item.ToolTip) }}</span>
                        </template>
                    </template>
                    <i class="fas fa-caret-down ribbon-button-has-ch" v-if="item.Items"></i> 
                </v-popover>
            </v-btn>

        </div>

        <slot>
        </slot>


    </div>

</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
    name: "Toolbar",
    props: {
        isList: {
            type: Boolean,
            default: false
        },
        hideCreateButton: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
        }
    },
    computed:{
        ...mapGetters('documents/toolbar', ['isToolbarLock', 'lockedActions', 'getMenu', 'getIcons']),
    },    
    methods: {
        ...mapActions(['setOverlayVisible']),
        mapIcon (source) {
            return this.getIcons[source] ?? "fas fa-ban";
        },
        btnIsLock(btnAction){
            return this.isToolbarLock || this.lockedActions.indexOf(btnAction) > -1;
        },
        onToolbarButtonClick(event, button) {
            if (!button.Items)
                this.$emit('toolbar-button-click', event, button);
        },
        stickyFPanel() {
            var parent = document.getElementsByClassName('content-box')[0];
            var top_btns_bar_obj = parent.getElementsByClassName('top-btns-bar');
            var white_panel_obj = parent.getElementsByClassName('white-panel-items');
            var tabs_card_btn_obj = parent.getElementsByClassName('tab-selector-panel');
            var after_tabs_card_btn_obj = parent.getElementsByClassName('after-tabs-part-wrapper');

            var toolbar_h = 0;
            if(top_btns_bar_obj.length > 0){
                toolbar_h = top_btns_bar_obj[0].clientHeight + 10;
            }else{
                toolbar_h = 5;
            }
            
            var white_panel_h = 0;
            if(white_panel_obj.length > 0){
                Array.from(white_panel_obj).forEach(el => {
                    white_panel_h += el.clientHeight + 10;
                });
            }
            var tabs_margin_top = white_panel_obj.length > 0 ? 10 : 0;

            if (white_panel_obj.length > 0) {
                white_panel_obj[0].style.top = toolbar_h + "px";
            }

            if (after_tabs_card_btn_obj.length > 0) {
                after_tabs_card_btn_obj[0].style.top = (toolbar_h + white_panel_h + tabs_margin_top) + "px";
            }
            else {
                if (tabs_card_btn_obj.length > 0) {
                    tabs_card_btn_obj[0].style.top = (toolbar_h + white_panel_h + tabs_margin_top) + "px";
                }
            }
        }
    },
    mounted() {
        this.$nextTick(this.stickyFPanel);
        window?.addEventListener('resize', this.stickyFPanel);
    },
    watch: {
        menu() {
            this.$nextTick(function() {
                this.stickyFPanel();
            });
        }
    },
    beforeDestroy() {
        window?.removeEventListener('resize', this.stickyFPanel);
    }
}
</script>